    <div class="carousel-inner">
       
         <div class="carousel-item"
            *ngFor="let item of oneColCarouselText_items"
            [ngClass]="{'active': item.active}"
         >
          <img src="https://{{item.imgSrc}}" class="d-block img-full-cover" alt="{{item.imgAlt}}">
              <div class="carousel-caption d-md-block position-absolute top-50 start-50 translate-middle">
                                <h5 class="text-uppercase light fw-bold">{{item.text}}</h5>
                
              </div>
         </div>
        

    </div>
     <div class="controls bg-grey">
             <div class="controls-blq">
                    <button class="carousel-control-prev" type="button" data-bs-target="#carousel4" data-bs-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Previo</span>
                    </button>
                   <button class="carousel-control-next" type="button" data-bs-target="#carousel4" data-bs-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Siguiente</span>
                   </button>
            </div>       
      </div>

